module.exports = __webpack_public_path__ + "static/me_inverted-ab9b14455e244db47968073777e53dd1.jpg";